import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { IIcon } from '../../../shared/components/icon/icon.interface';
import { IconSizesEnum } from '../../../shared/components/icon/icons-sizes.enum';

@Component({
  selector: 'app-account-menu-trigger',
  templateUrl: 'account-menu-trigger.component.html',
  styleUrls: ['account-menu-trigger.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountMenuTriggerComponent implements OnInit {
  @Input() companyName: string;
  @Input() userEmail: string;

  @Output() onToggleMenu: EventEmitter<boolean> = new EventEmitter<boolean>();

  isOpen: boolean;
  chevronDownIcon: IIcon;

  constructor(private _changeDetectorRef: ChangeDetectorRef) {}

  ngOnInit() {
    this.chevronDownIcon = {
      name: 'chevron-down',
      size: IconSizesEnum.small,
    };
  }

  toggleDropdown() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  close() {
    this.isOpen = false;

    this.onToggleMenu.emit(false);

    this._changeDetectorRef.markForCheck();
  }

  open() {
    this.isOpen = true;

    this.onToggleMenu.emit(true);

    this._changeDetectorRef.markForCheck();
  }
}
